<template>
  <div id="orderCompleted">
    <div  v-if="!getMobile" id="navigation">
      <div style="position: relative;">
        <Navigation />
      </div>
    </div>
    <div v-if="getMobile">
      <NavigationMobile />
    </div>

    <div :class="{centerElement : !getMobile, mobile : getMobile}">
      <div>
      </div>
      <div style="padding-top: 70px;">
        <h3>
          {{getText.cart.orderFailure}}
        </h3>
        <a href="tel:004915154332276" style="text-decoration: none !important;">
          <div class="text-center" >
            <v-btn class="ma-2" color="var(--accentColor)"><span style="color:var(--mainColor);">0151 5433 2276</span></v-btn>
          </div>
        </a>
        <a href="mailto:info@rho-17.de?subject=Hallo,%20ich%20habe%20eine%20Frage" style="text-decoration: none !important;">
          <div class="text-center">
            <v-btn class="ma-2" color="var(--accentColor)"><span style="color:var(--mainColor);">{{getText.main.footer.mail}}</span></v-btn>
          </div>
        </a>
      </div>
      <div>
      </div>
    </div>

  </div>
</template>

<script>
  import Navigation from '@/components/Navigation.vue'
  import NavigationMobile from '@/components/NavigationMobile.vue'
  // import router from '@/router/index.js'

export default {
  name: 'orderCompleted',
  components: {
    Navigation,
    NavigationMobile
  },
  data() {
    return{
      customerOrigin: {normalOrigin: "", otherOrigin:""},
    }
   },
   computed: {
     getText(){return this.$store.getters.getText},
     getMobile(){return this.$store.getters.getAnimationProperties.mobile;},
   },
   methods: {
   },
   mounted (){
     this.$store.dispatch("setNavbarActive", 6);
     window.scrollTo(0, 0)
   },
}
</script>

<style scoped>
#purchaseInfoWrapper{
  background-color: var(--accentColorShaded);
  padding: 30px 15px;
  margin: 50px 0;
}
.purchaseInfo{
  position: relative;
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin-top: 15px;
  }
.checkoutDesktop{
  max-width: 350px;
  box-sizing: content-box;
  padding: 0 100px;
}
.cardWrapper{
  margin: 15px 0;
}
.card{
  position: relative;
  display: grid;
  grid-template-columns: 80px 1fr;
  padding: 15px 10px 15px 0;
}
  .mobile{
    margin: 0 10px;
  }
  #orderCompleted {
    position: relative;
    top: var(--desktopNavigationHeight);
    padding-bottom: 60px;
  }
  #cartMain {
    min-height: calc(90vh - var(--desktopNavigationHeight));
  }
  #cancelled{
    width: 285px;
    background-color: #F99;
    margin: auto;
    padding: 20px 0;
  }

</style>
